import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle } from 'lucide-react';
import useSettingsStore from '../store/useSettingsStore';
import { MaxBadge } from './MaxBadge';
import { isValidLink } from '../lib/links';

export default function Footer() {
  const settings = useSettingsStore(s => s.settings);
  const content = useSettingsStore(s => s.content);
  const footer = content?.footer || {};
  const companyName = content?.header?.company_name || settings?.site_title || 'AvtoPrime';

  return (
    <footer data-testid="main-footer" className="mt-16 border-t border-white/5 bg-[var(--ap-surface)]">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              {settings?.logo_url && (
                <img src={settings.logo_url} alt={companyName} className="h-10 w-10 rounded-full object-cover" loading="lazy" />
              )}
              <span className="text-lg font-bold">{companyName}</span>
            </div>
            <p className="text-sm text-[var(--ap-text-muted)] leading-relaxed">
              {footer.description || 'Подбор и продажа премиальных автомобилей'}
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[var(--ap-text-muted)] mb-4">Навигация</h4>
            <nav className="flex flex-col gap-2">
              {[
                { path: '/catalog', label: 'Каталог' },
                { path: '/configurator', label: 'Подбор авто' },
                { path: '/services', label: 'Услуги' },
                { path: '/reviews', label: 'Отзывы' },
                { path: '/about', label: 'О компании' },
              ].map(item => (
                <Link key={item.path} to={item.path} className="text-sm text-white/60 hover:text-white transition-colors">
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contacts */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-[var(--ap-text-muted)] mb-4">Контакты</h4>
            <div className="flex flex-col gap-3">
              {(settings?.contacts_info || []).filter(c => isValidLink(c.telegram) || isValidLink(c.whatsapp)).map((c, i) => (
                <div key={i} className="flex items-center gap-3">
                  {c.photo && <img src={c.photo} alt={c.name} className="w-8 h-8 rounded-full object-cover" loading="lazy" />}
                  <div>
                    <p className="text-sm font-medium">{c.name}</p>
                    <div className="flex gap-2 mt-1">
                      {isValidLink(c.telegram) && <a href={c.telegram.trim()} target="_blank" rel="noopener noreferrer" className="text-xs text-[var(--ap-primary)] hover:underline">Telegram</a>}
                      {isValidLink(c.whatsapp) && <a href={c.whatsapp.trim()} target="_blank" rel="noopener noreferrer" className="text-xs text-green-500 hover:underline">WhatsApp</a>}
                    </div>
                  </div>
                </div>
              ))}

              <MaxBadge testId="footer-max-badge" className="self-start text-sm px-4 py-2.5" />

              <p className="text-sm text-[var(--ap-text-muted)] mt-2">
                {content?.contacts?.work_hours || 'Пн-Пт: 9:00 — 20:00'}
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 text-center">
          <p className="text-xs text-[var(--ap-text-muted)]">
            {footer.copyright || `\u00A9 ${new Date().getFullYear()} ${companyName}. Все права защищены.`}
          </p>
        </div>
      </div>
    </footer>
  );
}
